export const BrowserFrame = ({ url, children, className = "" }) => (
  <div
    className={`rounded-xl border border-white/10 bg-[#101012] shadow-[0_40px_120px_-20px_rgba(0,0,0,0.85)] overflow-hidden ${className}`}
  >
    <div className="flex items-center gap-3 px-4 py-3 border-b border-white/5 bg-[#141416]">
      <div className="flex gap-1.5" aria-hidden="true">
        <span className="w-2.5 h-2.5 rounded-full bg-white/10" />
        <span className="w-2.5 h-2.5 rounded-full bg-white/10" />
        <span className="w-2.5 h-2.5 rounded-full bg-white/10" />
      </div>
      <div className="flex-1 max-w-xs mx-auto rounded-md bg-white/5 px-3 py-1 mono text-[10px] text-neutral-500 text-center tracking-wider truncate">
        {url}
      </div>
      <div className="w-10" aria-hidden="true" />
    </div>
    <div className="relative overflow-hidden">{children}</div>
  </div>
);
